/**
 * String helpers used across the app (e.g. display names, initials).
 */
export const getInitials = (firstName: string = '', lastName: string = ''): string => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};
